export const PRODUCT_SEARCH_LOADING = "product_search_loading";
export const PRODUCT_SEARCH_FORM = "product_search_form";
export const CHARTER_TIME_SELECTION = "charter_time_selection";
export const ORIGIN_FILTER = "origin_filter";
export const DESTINATION_FILTER = "destination_filter";
export const PUBLISHED_FARE_RESULTS = "published_fare_results";
export const ORIGIN_SEARCH = "origin_search";
export const DESTINATION_SEARCH = "destination_search";
export const DATE_SEARCH = "date_search";
export const ADD_FLIGHT = "add_flight";
